import React from 'react';
import { Alert } from 'antd';

/**
 * Renders the per-line `errors[]` array a 400 issuance response carries
 * (`{company_user, employee, emp_no, uniform_item, uniform_item_name, size,
 * size_code, quantity, error}` per row — see uniformErrorMessage's sibling
 * `error` string for the single display message; this is the structured
 * detail behind it) as one line per row: "<employee> – <uniform> – Size
 * <code>: <error>", omitting any part the row doesn't carry.
 */
const buildLine = (row) => {
  const parts = [];
  if (row.employee) parts.push(row.employee);
  if (row.uniform_item_name) parts.push(row.uniform_item_name);
  if (row.size_code) parts.push(`Size ${row.size_code}`);
  const prefix = parts.join(' – ');
  return prefix ? `${prefix}: ${row.error}` : row.error;
};

const IssuanceErrorList = ({ errors }) => {
  if (!Array.isArray(errors) || errors.length === 0) return null;

  return (
    <Alert
      type="error"
      showIcon
      className="mb-3"
      message={`${errors.length} line${errors.length > 1 ? 's' : ''} could not be issued`}
      description={
        <ul className="mb-0 ps-3">
          {errors.map((row, idx) => (
            <li key={`${row.uniform_item}-${row.size ?? 'none'}-${idx}`}>{buildLine(row)}</li>
          ))}
        </ul>
      }
    />
  );
};

export default IssuanceErrorList;
